<template>
  <header class="app-header navbar">
    <slot />
  </header>
</template>
<script>
export default {
  name: 'Navbar',

  created() {
    this._navbar = true;
  },
};
</script>



// WEBPACK FOOTER //
// Navbar.vue?05a1ae13